import { AlertTriangle, CheckCircle, AlertCircle } from 'lucide-react'

const statusConfig = {
  critical: {
    bg: 'bg-red-900/40',
    border: 'border-red-500',
    badge: 'bg-red-500',
    text: 'KRİTİK',
    icon: <AlertTriangle className="w-6 h-6 text-red-400" />,
    pulse: true
  },
  warning: {
    bg: 'bg-yellow-900/40',
    border: 'border-yellow-500',
    badge: 'bg-yellow-500',
    text: 'UYARI',
    icon: <AlertCircle className="w-6 h-6 text-yellow-400" />,
    pulse: false
  },
  normal: {
    bg: 'bg-green-900/20',
    border: 'border-green-600',
    badge: 'bg-green-500',
    text: 'NORMAL',
    icon: <CheckCircle className="w-6 h-6 text-green-400" />,
    pulse: false
  }
}

export default function MachineCard({ machine, onClick }) {
  const status = machine.ai_status || machine.status || 'normal'
  const cfg = statusConfig[status] || statusConfig.normal
  const prob = machine.ai_probability
    ? Math.round(parseFloat(machine.ai_probability) * 100)
    : 0

  return (
    <div
      onClick={() => onClick(machine)}
      className={`
        cursor-pointer rounded-xl border-2 p-5
        ${cfg.bg} ${cfg.border}
        hover:scale-105 transition-transform duration-200
      `}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          {cfg.icon}
          <span className="font-semibold text-lg">{machine.name}</span>
        </div>
        <span className={`text-xs font-bold px-2 py-1 rounded-full text-white ${cfg.badge}`}>
          {cfg.text}
        </span>
      </div>

      <div className="text-sm text-slate-400 mb-3">
        Hat: <span className="text-slate-200 font-medium">{machine.hat_type}</span>
      </div>

      <div className="mt-2">
        <div className="flex justify-between text-sm mb-1">
          <span className="text-slate-400">Arıza İhtimali</span>
          <span className={`font-bold ${
            prob >= 70 ? 'text-red-400' :
            prob >= 40 ? 'text-yellow-400' :
            'text-green-400'
          }`}>%{prob}</span>
        </div>
        <div className="w-full bg-slate-700 rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all duration-500 ${
              prob >= 70 ? 'bg-red-500' :
              prob >= 40 ? 'bg-yellow-500' :
              'bg-green-500'
            }`}
            style={{ width: `${prob}%` }}
          />
        </div>
      </div>

      <div className="text-xs text-slate-500 mt-3">
        Son güncelleme: {machine.last_update
          ? new Date(machine.last_update).toLocaleTimeString('tr-TR')
          : '-'}
      </div>
    </div>
  )
}